module.exports = __webpack_public_path__ + "static/img/Ned-Guy.5dc6a1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ned-Guy.jpg
// module id = Z9xS
// module chunks = 1